import React, { useEffect, useState } from "react";
import jwt_decode from "jwt-decode";
import { useNavigate } from "react-router-dom";

const SearchBar = () => {
  const navigate = useNavigate();
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("token");

    if (!token) {
      console.error("Token not found in localStorage.");
      return;
    }

    try {
      const decoded = jwt_decode(token);
      const userRole = decoded?.role || "";
      setIsAdmin(userRole.toLowerCase().includes("admin"));
    } catch (error) {
      console.error("Invalid token format.", error);
    }
  }, []);

  // The header's \"Viewing supplier\" card already exposes a Change button
  // that navigates to the same /Search route, so we no longer need a
  // separate toolbar search pill on the page. Keep this component as a
  // no-op to avoid layout duplication.
  return null;
};

export default SearchBar;
